import React from 'react';
import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import Swal from "sweetalert2";

function Purchases() {
    const navigate = useNavigate();
    const [expandedRows, setExpandedRows] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [ldata, setLdata] = useState(null);





    const [isReturnOpen, setIsReturnOpen] = useState(false);
    const [returnPurchase, setReturnPurchase] = useState(null); // full purchase + items
    const [returnRows, setReturnRows] = useState([]);           // editable return qty rows
    const [returnNote, setReturnNote] = useState("");
    const [returnLoading, setReturnLoading] = useState(false);
     
    // For reprint
    const [isReprintOpen, setIsReprintOpen] = useState(false);
    const [reprintList, setReprintList] = useState([]);
    const [reprintPurchase, setReprintPurchase] = useState(null);






    // Payment Modal State
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState("");

    const [formData, setFormData] = useState({
        l1: [],
        purchase_type: 'normal',
        page_no: 0,
        search_key: '',
        from_date: new Date().toISOString().split('T')[0], // Current date
        to_date: new Date().toISOString().split('T')[0]     // Current date
    });

    const [totals, setTotals] = useState({
        totalAmount: 0,
        paidAmount: 0,
        dueAmount: 0,
        totalTaxCharges: 0,
    });
    const isAdminUser = () => {
        try {
          const raw = sessionStorage.getItem('ldata');
          if (!raw) return false;
          const user = JSON.parse(raw);
          return String(user?.role_id) === '1';
        } catch (e) {
          return false;
        }
      };

      const attachUserInfo = (fd) => {
        try {
          const stored = sessionStorage.getItem("ldata");
          if (stored) {
            const u = JSON.parse(stored);
            fd.append('user_id',   u.user_id   || '');
            fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
            fd.append('user_role', u.role_id   || u.role_name || '');
          }
        } catch (e) {
          console.warn("attachUserInfo failed:", e);
        }
        return fd;
    };
    
    const isWithin24Hours = (purchaseDatetime) => {


  if (!purchaseDatetime) return false;

  // handle "YYYY-MM-DD HH:MM:SS"
  const created = new Date(purchaseDatetime.replace(' ', 'T'));
  if (isNaN(created)) return false;

  const HOURS_24 = 24 * 60 * 60 * 1000;
  return (Date.now() - created.getTime()) <= HOURS_24;
};
      
    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        
        if (roleId === 1 || roleId === "1") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

        if (storedData) {
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            // REMOVED: fd.append('purchase_user', 1 + ""); // No user filter
            fd.append('purchase_type', formData.purchase_type);
            fd.append('from_date', formData.from_date + "");
            fd.append('to_date', formData.to_date + "");

            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getPurchaseListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClearFilters = () => {
        const today = new Date().toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            search_key: "",
            from_date: today,
            to_date: today,
        }));
    };

    const delItem = async (item) => {

        // 🔒 ADMIN CHECK (frontend safety)
        if (!isAdmin) {
            toast.error("Only admin can delete purchases");
            return;
        }
    
        const result = await Swal.fire({
            title: "Delete Purchase?",
            text: "This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel"
        });
    
        if (!result.isConfirmed) return;
    
        const fd = new FormData();
        fd.append("purchase_id", item.purchase_id);
        attachUserInfo(fd); 
        try {
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.delPurchaseUrl,
                fd
            );
    
            if (response.data.status) {
                toast.success("Purchase deleted successfully");
                initData(); // reload list
            } else {
                toast.error(response.data.message || "Delete failed");
            }
        } catch (error) {
            toast.error("Failed to delete purchase");
            console.error(error);
        }
    };
    

    const canEdit = (purchaseDate) => {
        if (isAdmin) return true;
        
        const purchase = new Date(purchaseDate);
        const now = new Date();
        const diffInHours = (now - purchase) / (1000 * 60 * 60);
        
        return diffInHours <= 24;
    };

    // Payment Modal Handlers
    const handleOpenModal = (item) => {
        setSelectedPurchase(item);
        setPaymentAmount("");
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedPurchase(null);
    };

    const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        
        const payValue = parseFloat(paymentAmount);
        const dueValue = parseFloat(selectedPurchase.purchase_due);

        if (isNaN(payValue) || payValue <= 0) {
            toast.error("Please enter a valid payment amount.");
            return;
        }

        if (payValue > dueValue) {
            toast.error(`Payment amount cannot be more than the due amount of ${dueValue}.`);
            return;
        }

        const fd = new FormData();
        fd.append('purchase_id', selectedPurchase.purchase_id);
        fd.append('paid_amount', payValue);
        
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.makePurchasePaymentUrl, fd);

            if (response.data.status) {
                toast.success("Payment updated successfully!");
                handleCloseModal();
                initData();
            } else {
                toast.error(response.data.message || "Failed to update payment.");
            }
        } catch (error) {
            toast.error("An error occurred while processing the payment.");
            console.error("Payment submission error:", error);
        }
    };





    const canReturn = (row) => {
        if (isAdmin) return true;
        return isWithin24Hours(row.purchase_datetime);
    };
     
    // Open return modal — fetch fresh detail (current stock) from server
    const handleOpenReturn = async (row) => {
        if (!canReturn(row)) {
            const created = new Date(row.purchase_datetime.replace(' ', 'T'));
            const unlockAt = new Date(created.getTime() + 24 * 60 * 60 * 1000);
            Swal.fire({
                icon: 'info',
                title: 'Return Locked',
                html: `Returns allowed within <b>24 hours</b> of purchase.<br>
                       Created: <b>${created.toLocaleString()}</b><br>
                       Window ended: <b>${unlockAt.toLocaleString()}</b><br><br>
                       Only admin can return after this window.`
            });
            return;
        }
     
        try {
            const fd = new FormData();
            fd.append('purchase_id', row.purchase_id);
            const res = await axios.post(AppConst.BASE_URL + AppConst.getPurchaseForReturnUrl, fd);
     
            if (!res.data.status) {
                toast.error(res.data.message || 'Failed to load purchase');
                return;
            }
     
            const rec = res.data.record;
            setReturnPurchase(rec);
     
            // Pre-fill editable rows — default return qty = 0
            const rows = (rec.items || []).map(it => ({
                purchase_item_id:   it.purchase_item_id,
                medicine:           it.purchase_item_medicine,
                medicine_id:        it.purchase_item_medicine_id,
                batch:              it.purchase_item_batch,
                purchased_qty:      parseFloat(it.purchase_item_qty) || 0,
                purchased_free:     parseFloat(it.purchase_item_free) || 0,
                current_qty_stock:  parseFloat(it.purchase_item_qty_stock) || 0,
                current_tab_stock:  parseFloat(it.purchase_item_tab_cap_stock) || 0,
                already_returned_qty: parseFloat(it.purchase_item_returned_qty) || 0,
                already_returned_tab: parseFloat(it.purchase_item_returned_tab_cap) || 0,
                pur_price:          parseFloat(it.purchase_item_pur_price) || 0,
                mrp:                parseFloat(it.purchase_item_mrp) || 0,
                discount:           parseFloat(it.purchase_item_discount) || 0,
                gst:                parseFloat(it.purchase_item_gst) || 0,
                tab_cap_per_strip:  parseFloat(it.purchase_item_tab_cap) || 0,
                qty_return:         "",
                tab_cap_return:     "",
            }));
     
            setReturnRows(rows);
            setReturnNote("");
            setIsReturnOpen(true);
        } catch (err) {
            console.error(err);
            toast.error("Failed to load purchase for return");
        }
    };
     
    const handleCloseReturn = () => {
        setIsReturnOpen(false);
        setReturnPurchase(null);
        setReturnRows([]);
        setReturnNote("");
    };
     
    // Update a single return row field
    const handleReturnRowChange = (index, field, value) => {
        setReturnRows(prev => {
            const copy = [...prev];
            copy[index] = { ...copy[index], [field]: value };
            return copy;
        });
    };
     
    // Per-row line total (qty-based)
    const computeRowTotal = (r) => {
        const qty  = parseFloat(r.qty_return) || 0;
        const loose = parseFloat(r.tab_cap_return) || 0;
     
        // Price per strip
        const priceAfterDisc = r.pur_price - (r.pur_price * (r.discount / 100));
        const strip_amt = priceAfterDisc * qty;
     
        // Loose units priced as fraction of a strip (if tab_cap_per_strip known)
        let loose_amt = 0;
        if (loose > 0 && r.tab_cap_per_strip > 0) {
            loose_amt = (priceAfterDisc / r.tab_cap_per_strip) * loose;
        }
     
        const subtotal = strip_amt + loose_amt;
        const gst_value = subtotal * (r.gst / 100);
        return {
            subtotal: subtotal,
            gst_value: gst_value,
            total: subtotal + gst_value,
        };
    };
     
    // Overall grand total for the return
    const returnGrandTotal = useMemo(() => {
        return returnRows.reduce((sum, r) => sum + computeRowTotal(r).total, 0);
    }, [returnRows]);
     
     
    // Submit the return
    const handleSubmitReturn = async () => {
        // Validate at least one row has qty
        const hasAny = returnRows.some(r =>
            (parseFloat(r.qty_return) || 0) > 0 || (parseFloat(r.tab_cap_return) || 0) > 0
        );
        if (!hasAny) {
            toast.error("Enter return qty for at least one item");
            return;
        }
     
        // Validate caps
        for (const r of returnRows) {
            const q = parseFloat(r.qty_return) || 0;
            const l = parseFloat(r.tab_cap_return) || 0;
            if (q > r.current_qty_stock) {
                toast.error(`${r.medicine}: Return qty (${q}) > current stock (${r.current_qty_stock})`);
                return;
            }
            if (l > r.current_tab_stock) {
                toast.error(`${r.medicine}: Loose return (${l}) > loose stock (${r.current_tab_stock})`);
                return;
            }
        }
     
        const payload = returnRows
            .filter(r => (parseFloat(r.qty_return) || 0) > 0 || (parseFloat(r.tab_cap_return) || 0) > 0)
            .map(r => {
                const t = computeRowTotal(r);
                return {
                    purchase_item_id: r.purchase_item_id,
                    medicine:         r.medicine,
                    medicine_id:      r.medicine_id,
                    batch:            r.batch,
                    qty_return:       parseFloat(r.qty_return) || 0,
                    tab_cap_return:   parseFloat(r.tab_cap_return) || 0,
                    pur_price:        r.pur_price,
                    mrp:              r.mrp,
                    discount:         r.discount,
                    gst:              r.gst,
                    gst_value:        t.gst_value,
                    total:            t.total,
                };
            });
     
        const fd = new FormData();
        fd.append('purchase_id', returnPurchase.purchase_id);
        fd.append('return_note', returnNote);
        fd.append('return_user', ldata?.user_id || '');
        fd.append('return_items', JSON.stringify(payload));
     
        try {
            setReturnLoading(true);
            const res = await axios.post(AppConst.BASE_URL + AppConst.savePurchaseReturnUrl, fd);
     
            if (res.data.status) {
                toast.success("Return saved");
                // Build a print payload from what we already have
                const printData = {
                    return_invoice: res.data.return_invoice,
                    return_id:      res.data.return_id,
                    return_date:    new Date().toISOString().split('T')[0],
                    return_total:   returnGrandTotal,
                    supplier:       returnPurchase.purchase_supplier,
                    parent_invoice: returnPurchase.purchase_invoice,
                    items:          payload,
                    note:           returnNote,
                };
                handleCloseReturn();
                initData();
                // Auto-open print window
                printReturnInvoice(printData);
            } else {
                toast.error(res.data.message || "Failed to save return");
            }
        } catch (err) {
            console.error(err);
            toast.error("Error saving return");
        } finally {
            setReturnLoading(false);
        }
    };
     
     
    // ------------------------------------------------------------
    // [3] PRINT RETURN INVOICE (popup window)
    // ------------------------------------------------------------
     
    const printReturnInvoice = (data) => {
        const w = window.open('', '_blank', 'width=900,height=700');
        if (!w) {
            toast.error("Please allow popups to print");
            return;
        }
     
        const rows = (data.items || []).map((it, i) => `
            <tr>
                <td>${i + 1}</td>
                <td>${it.medicine || ''}</td>
                <td>${it.batch || '-'}</td>
                <td style="text-align:right">${it.qty_return || 0}</td>
                <td style="text-align:right">${it.tab_cap_return || 0}</td>
                <td style="text-align:right">₹ ${(it.pur_price || 0).toFixed(2)}</td>
                <td style="text-align:right">₹ ${(it.mrp || 0).toFixed(2)}</td>
                <td style="text-align:right">${it.discount || 0}%</td>
                <td style="text-align:right">${it.gst || 0}%</td>
                <td style="text-align:right">₹ ${(it.total || 0).toFixed(2)}</td>
            </tr>
        `).join('');
     
        const html = `
            <!doctype html>
            <html><head><title>Return Invoice - ${data.return_invoice}</title>
            <style>
                body { font-family: Arial, sans-serif; padding: 20px; color:#222; }
                h2 { margin:0 0 5px; }
                .meta { display:flex; justify-content:space-between; margin:15px 0; font-size:13px; }
                .meta div { line-height:1.6 }
                table { width:100%; border-collapse: collapse; font-size:12px; }
                th, td { border:1px solid #888; padding:6px 8px; }
                th { background:#f2f2f2; }
                .total-row td { font-weight:bold; background:#fafafa; }
                .note { margin-top:15px; font-size:12px; }
                .sign { margin-top:60px; display:flex; justify-content:space-between; font-size:12px; }
            </style>
            </head>
            <body>
                <h2>Purchase Return Invoice</h2>
                <div style="font-size:12px;color:#666">Invoice No: <b>${data.return_invoice}</b></div>
     
                <div class="meta">
                    <div>
                        <b>Supplier:</b> ${data.supplier || '-'}<br>
                        <b>Original Invoice:</b> ${data.parent_invoice || '-'}
                    </div>
                    <div>
                        <b>Return Date:</b> ${data.return_date}<br>
                        <b>Return ID:</b> ${data.return_id}
                    </div>
                </div>
     
                <table>
                    <thead>
                        <tr>
                            <th>#</th><th>Medicine</th><th>Batch</th>
                            <th>Qty (Strips)</th><th>Loose</th>
                            <th>P. Rate</th><th>MRP</th>
                            <th>Disc%</th><th>GST%</th><th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${rows}
                        <tr class="total-row">
                            <td colspan="9" style="text-align:right">Grand Total</td>
                            <td style="text-align:right">₹ ${(data.return_total || 0).toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
     
                ${data.note ? `<div class="note"><b>Note:</b> ${data.note}</div>` : ''}
     
                <div class="sign">
                    <div>_________________________<br>Prepared By</div>
                    <div>_________________________<br>Authorized Signature</div>
                </div>
     
                <script>
                    window.onload = () => { window.print(); };
                </script>
            </body></html>
        `;
        w.document.write(html);
        w.document.close();
    };
     
     
    // ------------------------------------------------------------
    // [4] REPRINT HANDLER
    // ------------------------------------------------------------
     
    const handleOpenReprint = async (row) => {
        try {
            const fd = new FormData();
            fd.append('purchase_id', row.purchase_id);
            const res = await axios.post(AppConst.BASE_URL + AppConst.getReturnsByPurchaseUrl, fd);
            if (!res.data.status) {
                toast.error(res.data.message || 'Failed');
                return;
            }
            if ((res.data.records || []).length === 0) {
                toast.info("No returns found for this purchase");
                return;
            }
            setReprintList(res.data.records);
            setReprintPurchase(row);
            setIsReprintOpen(true);
        } catch (err) {
            toast.error("Error loading returns");
        }
    };
     
    const handleReprintOne = async (return_id) => {
        const fd = new FormData();
        fd.append('return_id', return_id);
        const res = await axios.post(AppConst.BASE_URL + AppConst.getReturnInvoiceUrl, fd);
        if (!res.data.status) { toast.error(res.data.message); return; }
     
        const rec = res.data.record;
        printReturnInvoice({
            return_invoice: rec.return_invoice,
            return_id:      rec.return_id,
            return_date:    rec.return_date,
            return_total:   parseFloat(rec.return_total) || 0,
            supplier:       rec.return_supplier,
            parent_invoice: rec.parent?.purchase_invoice || '',
            items: (rec.items || []).map(it => ({
                medicine:       it.return_item_medicine,
                batch:          it.return_item_batch,
                qty_return:     it.return_item_qty,
                tab_cap_return: it.return_item_tab_cap,
                pur_price:      parseFloat(it.return_item_pur_price),
                mrp:            parseFloat(it.return_item_mrp),
                discount:       parseFloat(it.return_item_discount),
                gst:            parseFloat(it.return_item_gst),
                total:          parseFloat(it.return_item_total),
            })),
            note: rec.return_note,
        });
    };



    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }
    }, []);

    // Auto-reload when dates change
    useEffect(() => {
        if (formData.from_date && formData.to_date) {
            initData();
        }
    }, [formData.from_date, formData.to_date]);

    // Calculate totals
    useEffect(() => {
        let totalAmount = 0,
            paidAmount = 0,
            dueAmount = 0,
            totalTaxCharges = 0,
            totalMrp = 0;

        const toNum = (val) => {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        };

        formData.l1.forEach((purchase) => {
            totalAmount += toNum(purchase.purchase_total);
            paidAmount += toNum(purchase.purchase_paid);
            dueAmount += toNum(purchase.purchase_due);

            if (purchase.items && purchase.items.length > 0) {
                purchase.items.forEach((med) => {
                    totalTaxCharges += toNum(med.purchase_item_gst_value);
                    const qty = toNum(med.purchase_item_qty);
                const free = toNum(med.purchase_item_free);
                const mrp = toNum(med.purchase_item_mrp);

                totalMrp += (qty + free) * mrp;
                });
            }
        });

        setTotals({
            totalAmount,
            paidAmount,
            dueAmount,
            totalTaxCharges,
            totalMrp
        });
    }, [formData.l1]);

    // Expandable Row Component with Search
    const ExpandedComponent = ({ data }) => {
        const [medicineSearch, setMedicineSearch] = useState('');
        
        // Filter medicines based on search
        const filteredMedicines = data.items?.filter(med => 
            med.purchase_item_medicine?.toLowerCase().includes(medicineSearch.toLowerCase()) ||
            med.purchase_item_batch?.toLowerCase().includes(medicineSearch.toLowerCase())
        ) || [];
        
        return (
            <div className="p-3" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Purchase Details - Invoice: {data.purchase_invoice}</h6>
                    <div className="d-flex align-items-center gap-2">
                        <input 
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search medicine or batch..."
                            value={medicineSearch}
                            onChange={(e) => setMedicineSearch(e.target.value)}
                            style={{ width: '250px' }}
                        />
                        {medicineSearch && (
                            <button 
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => setMedicineSearch('')}
                            >
                                <i className="ri-close-line"></i>
                            </button>
                        )}
                        <span className="badge bg-info ms-2">
                            {filteredMedicines.length} / {data.items?.length || 0}
                        </span>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-bordered table-sm">
                        <thead style={{ backgroundColor: '#e9ecef' }}>
                            <tr>
                                <th>Medicine</th>
                                <th>Qty</th>
                                <th>Free</th>
                                <th>Strips</th>
                                <th>Exp Date</th>
                                <th>Disc (%)</th>
                                <th>Tax Amt</th>
                                <th>Batch</th>
                                <th>MRP</th>
                                <th>Gross Value</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredMedicines.length > 0 ? (
                                filteredMedicines.map((med, index) => (
                                    <tr key={index}>
                                         <td>
        {med.purchase_item_medicine}
        {parseFloat(med.purchase_item_returned_qty) > 0 && (
            <span className="badge bg-warning text-dark ms-2" title="Returned strips">
                ↩ {med.purchase_item_returned_qty} strips
            </span>
        )}
        {parseFloat(med.purchase_item_returned_tab_cap) > 0 && (
            <span className="badge bg-warning text-dark ms-1" title="Returned loose units">
                ↩ {med.purchase_item_returned_tab_cap} loose
            </span>
        )}
    </td>
                                        <td>{med.purchase_item_qty}</td>
                                        <td>{med.purchase_item_free}</td>
                                        <td>{med.purchase_item_tab_cap}</td>
                                        <td>
                                            {med.purchase_item_expiry_month && med.purchase_item_expiry_year
                                                ? `${med.purchase_item_expiry_month}/${med.purchase_item_expiry_year}`
                                                : "-"}
                                        </td>
                                        <td>{med.purchase_item_discount}</td>
                                        <td>{med.purchase_item_gst_value}</td>
                                        <td>{med.purchase_item_batch}</td>
                                        <td>{med.purchase_item_pur_price}</td>
                                        <td>{med.purchase_item_gross_value}</td>
                                        <td>{med.purchase_item_gtotal}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="11" className="text-center py-3 text-muted">
                                        <i className="ri-search-line fs-4"></i>
                                        <p className="mb-0 mt-2">No medicines found matching "{medicineSearch}"</p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    // Format date to DD-MMM-YYYY (e.g., 12-Oct-2025)
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                           'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    // DataTable Columns
    const columns = [
        {
            name: 'Invoice',
            selector: row => row.purchase_invoice,
            sortable: true,
            width: '150px'
        },
        {
            name: 'Date',
            selector: row => row.purchase_date,
            sortable: true,
            width: '130px',
            cell: row => formatDate(row.purchase_date)
        },
        {
            name: 'Supplier',
            selector: row => row.purchase_supplier,
            sortable: true,
            grow: 2
        },
        {
            name: 'Total',
            selector: row => row.purchase_total,
            sortable: true,
            width: '120px',
            right: true,
            cell: row => `₹${parseFloat(row.purchase_total || 0).toFixed(2)}`
        },
        {
            name: 'Paid',
            selector: row => row.purchase_paid || 0,
            sortable: true,
            width: '120px',
            right: true,
            cell: row => `₹${parseFloat(row.purchase_paid || 0).toFixed(2)}`
        },
        {
            name: 'Due',
            selector: row => row.purchase_due,
            sortable: true,
            width: '120px',
            right: true,
            cell: row => `₹${parseFloat(row.purchase_due || 0).toFixed(2)}`
        },
        {
            name: 'Status',
            width: '120px',
            cell: row => {
                const total = parseFloat(row.purchase_total || 0);
                const paid = parseFloat(row.purchase_paid || 0);
                const due = parseFloat(row.purchase_due || 0);
                
                // Determine payment status
                let badgeClass = '';
                let badgeText = '';
                
                if (paid >= total || due <= 0) {
                    // Fully paid
                    badgeClass = 'badge bg-success';
                    badgeText = 'Paid';
                } else if (paid > 0 && paid < total) {
                    // Partial payment
                    badgeClass = 'badge bg-warning text-dark';
                    badgeText = 'Partial';
                } else {
                    // Not paid
                    badgeClass = 'badge bg-danger';
                    badgeText = 'Not Paid';
                }
                
                return <span className={badgeClass}>{badgeText}</span>;
            }
        },
        {
            name: 'Actions',
            width: '360px',
            cell: (row) => {
                const admin     = isAdminUser();
                const editable  = canEdit(row.purchase_datetime);
                const returnable = canReturn(row);
                const hasReturns = row.has_returns || (row.returns && row.returns.length > 0);
         
                return (
                    <div className="d-flex gap-1 flex-wrap">
                        {/* PRINT (original) */}
                        <button className="btn btn-sm btn-outline-info">
                            <i className="ri-printer-line"></i>
                        </button>
         
                        {/* RETURN */}
                        <button
                            className="btn btn-sm btn-outline-warning"
                            title={returnable ? "Create Return" : "Return locked (24h)"}
                            style={{
                                opacity: returnable ? 1 : 0.5,
                                cursor: returnable ? 'pointer' : 'not-allowed'
                            }}
                            onClick={() => handleOpenReturn(row)}
                        >
                            <i className="ri-arrow-go-back-line"></i> Return
                        </button>
         
                        {/* REPRINT returns */}
                        {hasReturns && (
                            <button
                                className="btn btn-sm btn-outline-secondary"
                                title="View / Reprint Returns"
                                onClick={() => handleOpenReprint(row)}
                            >
                                <i className="ri-file-list-3-line"></i>
                            </button>
                        )}
         
                        {/* EDIT (original) */}
                        <button
                            className="btn btn-sm btn-outline-primary"
                            style={{
                                opacity: editable ? 1 : 0.5,
                                cursor: editable ? 'pointer' : 'not-allowed'
                            }}
                            onClick={() => {
                                if (!editable) {
                                    const created = new Date(row.purchase_datetime.replace(" ", "T"));
                                    const unlockAt = new Date(created.getTime() + 24 * 60 * 60 * 1000);
                                    Swal.fire({
                                        icon: 'info',
                                        title: 'Edit Locked',
                                        html: `Purchase created at:<br><b>${created.toLocaleString()}</b><br><br>
                                               Editing allowed only within <b>24 hours</b>.<br>
                                               You can edit until:<br><b>${unlockAt.toLocaleString()}</b>`
                                    });
                                    return;
                                }
                                sessionStorage.setItem("opd_dt", JSON.stringify(row));
                                navigate("/new_purchase");
                            }}
                        >
                            <i className="ri-pencil-line"></i>
                        </button>
         
                        {/* DELETE (original) */}
                        <button
                            className="btn btn-sm btn-outline-danger"
                            style={{
                                opacity: admin ? 1 : 0.5,
                                cursor: admin ? 'pointer' : 'not-allowed'
                            }}
                            onClick={() => admin ? delItem(row) : Swal.fire("Only admin can delete")}
                        >
                            <i className="ri-delete-bin-line"></i>
                        </button>
                    </div>
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        }
    ];

    // Custom styles for DataTable
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#405189',
                color: '#fff',
                fontSize: '14px',
                fontWeight: 'bold',
                borderRadius: '5px 5px 0 0'
            }
        },
        headCells: {
            style: {
                color: '#fff',
                paddingLeft: '16px',
                paddingRight: '16px'
            }
        },
        rows: {
            style: {
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                    cursor: 'pointer'
                }
            }
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">Purchases</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <button 
                                            type="button" 
                                            className="btn btn-success"
                                            onClick={() => {
                                                sessionStorage.removeItem("opd_dt");
                                                navigate("/new_purchase");
                                            }}
                                        >
                                            <i className="ri-add-line align-bottom me-1"></i> Add Purchase
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <label className="form-label">From Date</label>
                                        <input 
                                            className="form-control" 
                                            type="date" 
                                            name="from_date"
                                            onChange={handleChange} 
                                            value={formData.from_date} 
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">To Date</label>
                                        <input 
                                            className="form-control" 
                                            type="date" 
                                            name="to_date"
                                            onChange={handleChange} 
                                            value={formData.to_date} 
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label">&nbsp;</label>
                                        <div>
                                            <button 
                                                type="button" 
                                                onClick={handleClearFilters} 
                                                className="btn btn-info w-100"
                                            >
                                                <i className="ri-refresh-line me-1"></i> Clear
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Search</label>
                                        <input 
                                            className="form-control" 
                                            placeholder="Search by Invoice or Supplier..." 
                                            type="text"
                                            name="search_key" 
                                            onChange={handleChange} 
                                            value={formData.search_key} 
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="card-body pt-0">
                                <DataTable
                                    columns={columns}
                                    data={formData.l1}
                                    customStyles={customStyles}
                                    pagination
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                    expandableRows
                                    expandableRowsComponent={ExpandedComponent}
                                    highlightOnHover
                                    pointerOnHover
                                    responsive
                                    striped
                                    noDataComponent={
                                        <div className="text-center py-5">
                                            <i className="ri-file-list-line fs-1 text-muted"></i>
                                            <p className="mt-3">No purchases found</p>
                                        </div>
                                    }
                                />
                                
                                <div className="mt-3 p-3 bg-light rounded">
                                    <div className="row text-center">
                                        <div className="col-md-2">
                                            <strong>Total Amount:</strong>
                                            <div className="fs-5 text-primary">₹ {totals.totalAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-2">
                                            <strong>Total MRP:</strong>
                                            <div className="fs-5 text-primary">₹ {totals.totalMrp?.toFixed(2) || "0.00"}</div>
                                        </div>
                                        <div className="col-md-2">
                                            <strong>Paid Amount:</strong>
                                            <div className="fs-5 text-success">₹ {totals.paidAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-2">
                                            <strong>Due Amount:</strong>
                                            <div className="fs-5 text-danger">₹ {totals.dueAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-2">
                                            <strong>Total Tax:</strong>
                                            <div className="fs-5 text-info">₹ {totals.totalTaxCharges.toFixed(2)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Payment Modal */}
            {isModalOpen && selectedPurchase && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title">
                                    <i className="ri-money-dollar-circle-line me-2"></i>
                                    Make Payment
                                </h5>
                                <button type="button" className="btn-close btn-close-white" onClick={handleCloseModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <h6>Invoice: <span className="text-primary">{selectedPurchase.purchase_invoice}</span></h6>
                                    <p className="text-muted mb-0">Supplier: {selectedPurchase.purchase_supplier}</p>
                                </div>
                                <hr/>
                                <form onSubmit={handlePaymentSubmit}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Total Amount</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={`₹ ${selectedPurchase.purchase_total || ''}`} 
                                                readOnly 
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Paid So Far</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={`₹ ${selectedPurchase.purchase_paid || '0'}`} 
                                                readOnly 
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="form-label fw-bold text-danger">Amount Due</label>
                                            <input 
                                                type="text" 
                                                className="form-control bg-light fw-bold fs-5" 
                                                value={`₹ ${selectedPurchase.purchase_due || ''}`} 
                                                readOnly 
                                            />
                                        </div>
                                        <hr className="my-3"/>
                                        <div className="col-md-12">
                                            <label htmlFor="paymentInput" className="form-label fw-bold">
                                                Pay Amount <span className="text-muted">(Max: ₹{selectedPurchase.purchase_due})</span>
                                            </label>
                                            <div className="input-group input-group-lg">
                                                <span className="input-group-text">₹</span>
                                                <input 
                                                    type="number" 
                                                    id="paymentInput"
                                                    className="form-control" 
                                                    placeholder="Enter payment amount"
                                                    value={paymentAmount}
                                                    onChange={(e) => setPaymentAmount(e.target.value)}
                                                    max={selectedPurchase.purchase_due}
                                                    step="0.01"
                                                    autoFocus
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                                    <i className="ri-close-line me-1"></i> Close
                                </button>
                                <button type="button" className="btn btn-success" onClick={handlePaymentSubmit}>
                                    <i className="ri-check-line me-1"></i> Pay
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}







            {/* RETURN MODAL */}
{isReturnOpen && returnPurchase && (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
                <div className="modal-header bg-warning">
                    <h5 className="modal-title">
                        <i className="ri-arrow-go-back-line me-2"></i>
                        Purchase Return — Invoice: {returnPurchase.purchase_invoice}
                    </h5>
                    <button type="button" className="btn-close" onClick={handleCloseReturn}></button>
                </div>
                <div className="modal-body">
                    {/* Header details */}
                    <div className="row mb-3 g-2">
                        <div className="col-md-4">
                            <div className="p-2 bg-light rounded">
                                <small className="text-muted">Supplier</small>
                                <div><b>{returnPurchase.purchase_supplier}</b></div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="p-2 bg-light rounded">
                                <small className="text-muted">Purchase Date</small>
                                <div><b>{returnPurchase.purchase_date}</b></div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="p-2 bg-light rounded">
                                <small className="text-muted">Purchase Total</small>
                                <div><b>₹ {parseFloat(returnPurchase.purchase_total || 0).toFixed(2)}</b></div>
                            </div>
                        </div>
                    </div>
 
                    <div className="table-responsive">
                        <table className="table table-bordered table-sm align-middle">
                            <thead className="table-dark">
                                <tr>
                                    <th>Medicine</th>
                                    <th>Batch</th>
                                    <th>Purchased</th>
                                    <th>Current Stock</th>
                                    <th>Already Returned</th>
                                    <th>P. Rate</th>
                                    <th>MRP</th>
                                    <th>Disc%</th>
                                    <th>GST%</th>
                                    <th style={{ minWidth: 90 }}>Return Strips</th>
                                    <th style={{ minWidth: 90 }}>Return Loose</th>
                                    <th>Line Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {returnRows.map((r, i) => {
                                    const t = computeRowTotal(r);
                                    const noStock = r.current_qty_stock <= 0 && r.current_tab_stock <= 0;
                                    return (
                                        <tr key={i} style={{ backgroundColor: noStock ? '#fff5f5' : '' }}>
                                            <td>{r.medicine}</td>
                                            <td>{r.batch || '-'}</td>
                                            <td className="text-center">
                                                {r.purchased_qty} + {r.purchased_free}F
                                            </td>
                                            <td className="text-center">
                                                <span className="badge bg-success">
                                                    {r.current_qty_stock} strips
                                                </span>
                                                {r.current_tab_stock > 0 && (
                                                    <span className="badge bg-info ms-1">
                                                        {r.current_tab_stock} loose
                                                    </span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                {r.already_returned_qty > 0 && (
                                                    <span className="badge bg-warning text-dark">
                                                        {r.already_returned_qty} strips
                                                    </span>
                                                )}
                                                {r.already_returned_tab > 0 && (
                                                    <span className="badge bg-warning text-dark ms-1">
                                                        {r.already_returned_tab} loose
                                                    </span>
                                                )}
                                                {r.already_returned_qty === 0 && r.already_returned_tab === 0 && '-'}
                                            </td>
                                            <td>₹{r.pur_price.toFixed(2)}</td>
                                            <td>₹{r.mrp.toFixed(2)}</td>
                                            <td>{r.discount}%</td>
                                            <td>{r.gst}%</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    min="0"
                                                    max={r.current_qty_stock}
                                                    value={r.qty_return}
                                                    disabled={r.current_qty_stock <= 0}
                                                    onChange={(e) => handleReturnRowChange(i, 'qty_return', e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    min="0"
                                                    max={r.current_tab_stock}
                                                    value={r.tab_cap_return}
                                                    disabled={r.current_tab_stock <= 0}
                                                    onChange={(e) => handleReturnRowChange(i, 'tab_cap_return', e.target.value)}
                                                />
                                            </td>
                                            <td><b>₹ {t.total.toFixed(2)}</b></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
 
                    <div className="row mt-3">
                        <div className="col-md-8">
                            <label className="form-label">Note</label>
                            <textarea
                                className="form-control"
                                rows="2"
                                value={returnNote}
                                onChange={(e) => setReturnNote(e.target.value)}
                                placeholder="Reason for return (optional)"
                            />
                        </div>
                        <div className="col-md-4">
                            <div className="card bg-light">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between h4 mb-0">
                                        <span>Return Total:</span>
                                        <strong className="text-success">₹ {returnGrandTotal.toFixed(2)}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={handleCloseReturn} disabled={returnLoading}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-success" onClick={handleSubmitReturn} disabled={returnLoading}>
                        {returnLoading
                            ? <><i className="ri-loader-2-line"></i> Saving...</>
                            : <><i className="ri-save-line me-1"></i> Save & Print</>
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
)}
 
{/* REPRINT MODAL */}
{isReprintOpen && reprintPurchase && (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header bg-info text-white">
                    <h5 className="modal-title">Returns for Invoice {reprintPurchase.purchase_invoice}</h5>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setIsReprintOpen(false)}></button>
                </div>
                <div className="modal-body">
                    <table className="table table-bordered table-sm">
                        <thead className="table-light">
                            <tr>
                                <th>Return Invoice</th>
                                <th>Date</th>
                                <th className="text-end">Amount</th>
                                <th className="text-center">Print</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reprintList.map(r => (
                                <tr key={r.return_id}>
                                    <td>{r.return_invoice}</td>
                                    <td>{r.return_date}</td>
                                    <td className="text-end">₹ {parseFloat(r.return_total).toFixed(2)}</td>
                                    <td className="text-center">
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => handleReprintOne(r.return_id)}
                                        >
                                            <i className="ri-printer-line"></i> Print
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
)}
        </div>
    );
}

export default Purchases;